import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import componentSchema from './schema.json';

export default class MwCheckbox extends Component {
  @tracked everyoneCanInvite1 = true;
  @tracked everyoneCanInvite2 = false;
  @tracked everyoneCanInvite3 = false;
  @tracked everyoneCanInvite4 = true;
  @tracked everyoneCanInvite5 = false;
  @tracked everyoneCanInvite6 = false;
  @tracked everyoneCanInvite7 = true;
  @tracked everyoneCanInvite8 = false;
  @tracked everyoneCanInvite9 = false;
  @tracked everyoneCanInvite20 = false;
  @tracked everyoneCanInvite21 = false;
  @tracked everyoneCanInvite22 = false;
  @tracked everyoneCanInvite30 = false;
  @tracked everyoneCanInvite31 = false;
  @tracked everyoneCanInvite32 = false;

  // Component schema for universal builder
  get componentSchema() {
    return componentSchema;
  }
}